import mapConverters from './map_converters'
import mapModals from './map_modals'

export const defaultShapeOptions = {
  fillOpacity: 0.4,
  strokeWeight: 1
};


export default class DrawingManager {

  constructor(googleMap, markerManager, shapeEditor = null) {
    this.drawings = [];
    this.googleMap = googleMap;
    this.markerManager = markerManager;
    this.shapeEditor = shapeEditor;

    this._drawingInProgress = false;
    this._drawingsVisible = true;
    this.selectedShape = null;
    this.editingShape = null;

    // When the user clicks on the map, a dropdown, a button or a checkbox, remove any shape context menu that might be visible.
    this.googleMap.addListener('click',this.resetShapesMenu.bind(this));
    this.googleMap.addListener('drag',this.resetShapesMenu.bind(this));
    this.googleMap.addListener('zoom_changed',this.resetShapesMenu.bind(this));
    $(document).on('shown.bs.dropdown', this.resetShapesMenu.bind(this));
    window.addEventListener('cleanup-rightleft-content', this.resetShapesMenu.bind(this))
    $('button:not(#deleteDrawingBtn)').on('click',this.resetShapesMenu.bind(this));
    $('input:checkbox').on('click',this.resetShapesMenu.bind(this));
    $(window).on('resize',this.resetShapesMenu.bind(this));

    this._drawnShapeColorChangedListener = null;
    this._drawnShapeNameChangedListener = null;
    this._drawnShapeStartEditListener = null;

    // When drawing is handled externally (ShapeEditor), we still want
    // drawingInProgress() to return true so map click/hover menus don't fire.
    this._externalDrawingInProgress = false;
    this._savedClickableState = new WeakMap();
  }

  resetShapesMenu() {
    if (window.activeMenuController && window.activeMenuController.shieldsUp) {
      // Klingon: Damn you Kirk!
      return
    }
    if (window.activeOverlayController && window.activeOverlayController.shieldsUp) {
      // Darth Vadar: You have failed me for the LAST time!
      return
    }

    $('#drawnShapeManagementMenu').css({ display: 'none'});
    $('#colorChoices').addClass('hidden');
    this.selectedShape = null;
    this.resetAllShapesOpacity();
  }

  resetAllShapesOpacity() {
    this.drawings.forEach( function(shape) {
      shape.set('fillOpacity',mapConverters.defaultShapeProperties.fillOpacity);
    })
  }
  
  resetAllShapesClickability() {
    this.drawings.forEach( function(shape) {
      shape.setOptions({clickable: false});
    });
  }
  
  hasDrawings() {
    return this.drawings.length > 0;
  }

  drawingsVisible() {
    return this._drawingsVisible;
  }

  displayShapeContextMenu(x,y) {
    // Make sure we reset the color toggle in case we clicked on a shape while
    // this menu is open.
    $('#colorChoices').addClass('hidden')
    $('.drawnShapeColorToggle').removeClass('flexicon-270').addClass('flexicon-90')

    var windowWidth = $(window).width();
    var windowHeight = $(window).height();
    var menuWidth = $('#drawnShapeManagementMenu').width();
    var menuHeight = $('#drawnShapeManagementMenu').height();

    if (x + menuWidth > windowWidth) {
      x -= menuWidth;
    }
    x = Math.max(16, Math.min(x, windowWidth - menuWidth - 16));

    if (y + menuHeight > windowHeight) {
      y -= menuHeight;

      // If the menu is displaying upwards from the mouse
      // align the color selector with the bottom of the menu so it cant
      $('#colorChoices').css('top', 'auto');
      $('#colorChoices').css('bottom', 0 + 'px')
    } else {
      // Check to see if the color choices will go past the bottom of the
      // window. (Sorry for the hard coded value.  How to know the height
      // when it is hidden?)
      if (y + 290 > windowHeight) {
        // color choices would go off the screen.  Align it with the bottom of
        // the menu
        $('#colorChoices').css('top', 'auto');
        $('#colorChoices').css('bottom', 0 + 'px')
      } else {
        // Color choices should be aligned with the top of the menu.
        $('#colorChoices').css('top', 0 + 'px');
        $('#colorChoices').css('bottom', 'auto')
      }
    }

    if(this._drawnShapeColorChangedListener === null) {
      this._drawnShapeColorChangedListener = window.addEventListener('drawnShapeColorChanged', this.drawnShapeColorChangedHandler.bind(this));
    }

    if(this._drawnShapeNameChangedListener === null) {
      this._drawnShapeNameChangedListener = window.addEventListener('drawnShapeNameChanged', this.drawnShapeNameChangedHandler.bind(this));
    }

    if(this._drawnShapeStartEditListener === null) {
      this._drawnShapeStartEditListener = window.addEventListener('drawnShapeStartEdit', this.drawnShapeStartEditHandler.bind(this))
    }

    $('#drawnShapeManagementMenu').css({ left: x + 'px', top: y + 'px', display: 'block', 'z-index': 500});

  }

  createCircle(lat, lng, radiusInMeters, shapeName = 'Circle') {
    // Manually create a Google Maps Circle with the same options as drawn circles.
    // This is separate and unique from the event system that creates circles (Ex: radius search).
    // Returns a Google Maps Circle.
    let circleProperties = mapConverters.defaultShapeProperties;
    let circleOptions = $.extend({}, defaultShapeOptions, circleProperties);
    circleOptions.clickable = false;
    circleOptions.center = new google.maps.LatLng(lat, lng);
    circleOptions.radius = radiusInMeters;
    
    const circle = new google.maps.Circle(circleOptions);
    
    // Set the shape name
    circle.set('shapeName', shapeName);
    
    return circle;
  }

  add(shape, annotation) {
    shape.visible = this._drawingsVisible;
    if (annotation) {
      var shapeProperties = mapConverters.defaultShapeProperties

      var color = annotation?.Attributes?.Color ?? shapeProperties.fillColor;
      if (!color.startsWith('#')) {
        color = '#' + color;
      }

      shape.set('fillColor', color);
      shape.set('strokeColor', color);
      shape.set('strokeWeight', shapeProperties.strokeWeight);
      shape.set('strokeOpacity', shapeProperties.strokeOpacity);
      shape.set('fillOpacity', shapeProperties.fillOpacity);
      shape.set('shapeName', annotation.Attributes.Label);
    }

    // Ensure drawn shapes have a proper z-index to appear above unfiltered overlay shapes
    if (!shape.get('zIndex')) {
      shape.set('zIndex', 10);
    }

    this.drawings.push(shape);
    shape.setMap(this.googleMap);
    shape.addListener('click', this.handleShapeClick.bind(this, shape));
  }

  handleShapeClick(shape, event) {
    if ($('.shape-edit-in-progress').length > 0) {
      // We are editing a shape.  Dont show the menu.
      return;
    }

    if (this.selectedShape != null && this.selectedShape !== shape) {
      // If another shape was selected and displaying the context menu
      // set the other shape's opacity back to normal.
      this.selectedShape.set('fillOpacity', 0.5);
    }
    this.selectedShape = shape;
    shape.set('fillOpacity', 0.7);
    // Populate the context menu
    $('#drawnShapeColor .selected-color-inner').css('background-color', shape.get('fillColor')).attr('data-color', shape.get('fillColor'))
    $('#drawnShapeName').val(shape.get('shapeName')).attr('data-original-name', shape.get('shapeName'));
    $('#drawnShapeCondition').val(shape.condition)

    if (shape instanceof google.maps.Polygon && Flexmls.currentUser.role === 'private') {
      $('#shapeMenuAddToOverlay').parent().removeClass('hidden')
    } else {
      $('#shapeMenuAddToOverlay').parent().addClass('hidden')
    }

    this.displayShapeContextMenu(event.domEvent.pageX, event.domEvent.pageY);
  }


  deleteDrawing(shape) {
    shape.visible = false;
    var index = this.drawings.indexOf(shape);
    if (index >= 0) {
      shape.visible = false;
      shape.setMap(null);
      this.drawings.splice(index, 1);
    }
  }

  toggleVisibility(visible) {

    this.drawings.forEach((drawing) => {
      this.markerManager.setRadiusMarkerVisibility(drawing, visible);
      drawing.setVisible(visible);
    });
    this._drawingsVisible = visible;
  }

  getBoundsForMultipleShapes() {
    var bounds = null;
    if (this.drawings.length === 0) {
      return null;
    }
    const combinedBounds = new google.maps.LatLngBounds();

    this.drawings.forEach((drawing) => {
      if (drawing instanceof google.maps.Polygon) {
        // Extend bounds with every polygon vertex
        drawing.getPath().forEach(latLng => combinedBounds.extend(latLng));
      } else if (drawing instanceof google.maps.Rectangle) {
        // Clone rectangle bounds to avoid reference issues
        const rectBounds = drawing.getBounds();
        const sw = rectBounds.getSouthWest();
        const ne = rectBounds.getNorthEast();
        combinedBounds.union(new google.maps.LatLngBounds(sw, ne));
      } else {
        // For circles/polylines/markers, use default bounds
        combinedBounds.union(drawing.getBounds());
      }
    });
    return combinedBounds;
  }

  deleteAll() {
    if(this.drawings.length > 0) {
      this.drawings.forEach(function(drawing){
        drawing.setMap(null);
      });
      this.drawings = [];
    }
  }


  drawingInProgress() {
    if (this._drawingInProgress) return true;
    if (this._externalDrawingInProgress) return true;
    if (this.shapeEditor && typeof this.shapeEditor.mode === 'function') {
      return this.shapeEditor.mode() === 'drawing';
    }
    return false;
  }

  setExternalDrawingInProgress(inProgress) {
    this._externalDrawingInProgress = inProgress === true;
  }

  disableDrawingsClickability() {
    this.drawings.forEach((shape) => {
      try {
        if (!this._savedClickableState.has(shape)) {
          const current = (typeof shape.get === 'function') ? shape.get('clickable') : undefined;
          this._savedClickableState.set(shape, current);
        }
        if (typeof shape.setOptions === 'function') {
          shape.setOptions({ clickable: false });
        }
      } catch (e) {
        // ignore per-shape failures
      }
    });
  }

  restoreDrawingsClickability() {
    this.drawings.forEach((shape) => {
      try {
        const saved = this._savedClickableState.has(shape) ? this._savedClickableState.get(shape) : undefined;
        const clickable = (typeof saved === 'boolean') ? saved : true;
        if (typeof shape.setOptions === 'function') {
          shape.setOptions({ clickable });
        }
      } catch (e) {
        // ignore per-shape failures
      }
    });
    this._savedClickableState = new WeakMap();
  }

  highlightShape(shapeDef) {
    let self = this;
    this.drawings.forEach(function (shape){
      if (self.shapeDefsEqual(shape.condition,shapeDef)) {
        shape.set('fillOpacity',0.9);
        return;
      }
    });
  }

  unhighlightShape(shapeDef) {
    let self = this;
    this.drawings.forEach(function (shape){
      if (self.shapeDefsEqual(shape.condition,shapeDef)) {
        shape.set('fillOpacity',0.5);
        return;
      }
    });
  }

  shapeDefsEqual(shapeDef1, shapeDef2) {
    return (shapeDef1.replaceAll(', ', ',') === shapeDef2.replaceAll(', ', ','))
  }

  drawnShapeColorChangedHandler(event) {
    if (this.selectedShape !== null) {
      this.selectedShape.set('fillColor',event.detail.newColor)
      this.selectedShape.set('strokeColor',event.detail.newColor)
    }
  }

  drawnShapeNameChangedHandler(event) {
    if (this.selectedShape !== null) {
      this.selectedShape.set('shapeName',event.detail.newName)
    }
  }

  drawnShapeStartEditHandler(event) {
    if (this.selectedShape === null) {
      return;
    }
    this.markerManager.deleteMarkers();
    this.editingShape = this.selectedShape;
    this.selectedShape = null;
    // Use ShapeEditor for custom edit handles (no google setEditable).
    if (this.shapeEditor && typeof this.shapeEditor.editShape === 'function') {
      this.shapeEditor.editShape(this.editingShape);
    }

    const shapeEditControlDiv = document.createElement('div')
    shapeEditControlDiv.id = 'drawnShapeEditControlBtns'
    shapeEditControlDiv.dataset.existingShapeDef = event.detail.targetShape;
    shapeEditControlDiv.style.margin = '8px'

    const undoControlUI = this.createUndoEditBtn();
    shapeEditControlDiv.appendChild(undoControlUI);
    this._addShapeEditButtonHandler(undoControlUI, () => {
      if (this.shapeEditor && typeof this.shapeEditor.undo === 'function') {
        this.shapeEditor.undo();
      }
    });

    const redoControlUI = this.createRedoEditBtn();
    shapeEditControlDiv.appendChild(redoControlUI);
    this._addShapeEditButtonHandler(redoControlUI, () => {
      if (this.shapeEditor && typeof this.shapeEditor.redo === 'function') {
        this.shapeEditor.redo();
      }
    });

    const cancelControlUI = this.createCancelEditBtn(this.editingShape)
    shapeEditControlDiv.appendChild(cancelControlUI);
    this._addShapeEditButtonHandler(cancelControlUI, this.cancelShapeEdit);

    const doneControlUI = this.createDoneEditBtn();
    shapeEditControlDiv.appendChild(doneControlUI);
    this._addShapeEditButtonHandler(doneControlUI, this.drawnShapeEditComplete);


    // Add the control to the map (top right in this example)
    this.googleMap.controls[google.maps.ControlPosition.TOP_CENTER].push(shapeEditControlDiv);

    // Dont allow someone to create a new shape while we are editing this one.
    $('#drawOnMapBtn').prop('disabled', true);

    // Enable/disable undo/redo buttons based on history.
    if (this.shapeEditor && this.shapeEditor.options) {
      this.shapeEditor.options.onUndoStateChange = (canUndo, canRedo) => {
        try {
          undoControlUI.disabled = !canUndo;
          redoControlUI.disabled = !canRedo;
        } catch (e) {}
      };
      if (typeof this.shapeEditor.canUndo === 'function') {
        undoControlUI.disabled = !this.shapeEditor.canUndo();
      }
      if (typeof this.shapeEditor.canRedo === 'function') {
        redoControlUI.disabled = !this.shapeEditor.canRedo();
      }
    } else {
      undoControlUI.disabled = true;
      redoControlUI.disabled = true;
    }

    this._drawingInProgress = true;
  }

  drawnShapeEditComplete(event) {
    this._drawingInProgress = false;
    $('#drawOnMapBtn').prop('disabled', false);

    // Remove the click listener from the header.
    $('#drawingModeHeader').off('click', this.drawnShapeEditComplete.bind(this));

    // Get info from the edit buttons div and then clear it
    let originalShapeDef = $('#drawnShapeEditControlBtns').data('existingShapeDef');
    this.googleMap.controls[google.maps.ControlPosition.TOP_CENTER].clear();

    // If we are editing a shape (which we should be if we got here)...
    if (this.editingShape !== null) {
      if (this.shapeEditor && typeof this.shapeEditor.stopEditing === 'function') {
        this.shapeEditor.stopEditing();
      }
      if (this.shapeEditor && this.shapeEditor.options) {
        this.shapeEditor.options.onUndoStateChange = null;
      }

      // Tell flexmls_map to update the filters and annotations.  That is more
      // equipped to do that than the drawing manager.
      let myData = {
        detail:
        {
          oldShapeDef: originalShapeDef,
          newShape: this.editingShape
        }
      };
      window.dispatchEvent(new CustomEvent('map:drawnShapeEditComplete', myData));

      // We are no longer editing a shape.  And we dont need any more info from it.
      this.editingShape = null;
    }
  }

  cancelShapeEdit(event) {
    let originalShapeDef = $('#drawnShapeEditControlBtns').data('existingShapeDef');

    this._drawingInProgress = false;
    $('#drawOnMapBtn').prop('disabled', false);

    // If we are editing a shape (which we should be if we got here)...
    if (this.editingShape !== null) {
      const btn = event.currentTarget || event.target.closest('button') || event.target;
      const shapeType = btn.dataset.shapeType;
      const originalGeometry = JSON.parse(btn.dataset.originalGeometry);

      switch (shapeType) {
        case 'polygon':
          // setPaths can take Array<Array<LatLngLiteral>>
          this.editingShape.setPaths(originalGeometry);
          break;
        case 'polyline':
          // setPath can take Array<LatLngLiteral>
          this.editingShape.setPath(originalGeometry);
          break;
        case 'circle':
          this.editingShape.setCenter(originalGeometry.center);
          this.editingShape.setRadius(originalGeometry.radius);
          // Re-sync radius marker to original geometry.
          if (this.markerManager && typeof this.markerManager.addRadiusMarker === 'function') {
            this.markerManager.addRadiusMarker(this.editingShape);
          }
          break;
        case 'rectangle':
          // LatLngBounds constructor takes LatLngBoundsLiteral or two LatLngLiterals
          this.editingShape.setBounds(originalGeometry); // {north, south, east, west}
          break;
        default:
          console.error("Unknown shape type found on button data.");
          return;
      }

      if (this.shapeEditor && typeof this.shapeEditor.stopEditing === 'function') {
        this.shapeEditor.stopEditing();
      }
      if (this.shapeEditor && this.shapeEditor.options) {
        this.shapeEditor.options.onUndoStateChange = null;
      }
      // Clear the buttons from the top of the map
      this.googleMap.controls[google.maps.ControlPosition.TOP_CENTER].clear();

      // Tell flexmls_map to update the filters and annotations.  That is more
      // equipped to do that than the drawing manager.
      let myData = {
        detail:
        {
          oldShapeDef: originalShapeDef,
          newShape: null
        }
      };
      window.dispatchEvent(new CustomEvent('map:drawnShapeEditComplete', myData));

      // We are no longer editing a shape.  And we dont need any more info from it.
      this.editingShape = null;
    }
  }

  _addShapeEditButtonHandler(button, handler) {
    let touchHandled = false;
    button.addEventListener('touchend', (e) => {
      if (button.disabled) return;
      if (e.cancelable) e.preventDefault();
      touchHandled = true;
      handler.call(this, e);
      setTimeout(() => { touchHandled = false; }, 400);
    });
    button.addEventListener('click', (e) => {
      if (button.disabled) return;
      if (touchHandled) {
        touchHandled = false;
        return;
      }
      e.preventDefault();
      handler.call(this, e);
    });
  }

  _createShapeEditBtn(iconClass, label, { btnClass = 'btn-secondary', iconStyle = null } = {}) {
    const btn = document.createElement('button');
    btn.title = label;
    btn.className = `btn ${btnClass} shape-edit-in-progress shape-edit-btn`;

    const text = document.createElement('span');
    text.className = 'shape-edit-btn-label';
    text.textContent = label;
    btn.appendChild(text);

    const icon = document.createElement('span');
    icon.className = `flexicon ${iconClass}`;
    if (iconStyle) Object.assign(icon.style, iconStyle);
    btn.appendChild(icon);

    return btn;
  }

  createDoneEditBtn() {
    return this._createShapeEditBtn('flexicon-check', 'Done', { btnClass: 'btn-primary' });
  }

  createUndoEditBtn() {
    const btn = this._createShapeEditBtn('flexicon-refresh', 'Undo', {
      iconStyle: { transform: 'scaleX(-1)', display: 'inline-block' }
    });
    btn.disabled = true;
    return btn;
  }

  createRedoEditBtn() {
    const btn = this._createShapeEditBtn('flexicon-refresh', 'Redo');
    btn.disabled = true;
    return btn;
  }

  createCancelEditBtn(shape) {
    let shapeType = '';
    let originalShapeData = {};

    let cancelBtn = this._createShapeEditBtn('flexicon-close', 'Cancel');

    if (shape instanceof google.maps.Polygon) {
      shapeType = 'polygon';
      const paths = shape.getPaths().getArray();
      const pathLiterals = [];
      paths.forEach(mvcPath => {
        const singlePath = [];
        mvcPath.getArray().forEach(latLng => {
          singlePath.push({ lat: latLng.lat(), lng: latLng.lng() });
        });
        pathLiterals.push(singlePath);
      });
      originalShapeData = pathLiterals;
    } else if (shape instanceof google.maps.Circle) {
      shapeType = 'circle';
      const center = shape.getCenter();
      originalShapeData = {
        center: { lat: center.lat(), lng: center.lng() },
        radius: shape.getRadius()
      };
    } else if (shape instanceof google.maps.Rectangle) {
      shapeType = 'rectangle';
      const bounds = shape.getBounds();
      const ne = bounds.getNorthEast();
      const sw = bounds.getSouthWest();
      originalShapeData = {
        north: ne.lat(),
        east: ne.lng(),
        south: sw.lat(),
        west: sw.lng()
      };
    }

    // Store data on the button
    cancelBtn.dataset.shapeType = shapeType;
    cancelBtn.dataset.originalGeometry = JSON.stringify(originalShapeData); // Store as JSON string
    return cancelBtn;
  }

  displayOverlayManager(details, addShapeToOverlayModal) {
    const selectedShapeItemHiddenData =  `
      <input type="hidden" name="label_ITEMNUMBER" value="POLYGON_NAME">
      <input type="hidden" name="color_ITEMNUMBER" value="POLYGON_COLOR">
      <input type="hidden" name="coords_ITEMNUMBER" value="POLYGON_POINTS">
    `

    const selectedShapeItemFormGroup = `
      <div class="form-group">
        <label for="selected_ITEMNUMBER" style="display: flex; align-items: center; font-weight: 400 !important">
          <input type="checkbox" id="selected_ITEMNUMBER" value="Y" data-overlay-editor-modal-target="polygonCheckbox" data-action="change->overlay-editor-modal#validate" ISCHECKED>
          <span style="display: inline-block; width: 14px; height: 14px; border-radius: 50%; margin-left: 12px; background-color: POLYGON_COLOR;"></span>
          <span style="margin-left: 4px">POLYGON_NAME</span>
        </label>
      </div>
    `

    let polygonCount = 0;
    let allHiddenFields = '';
    let allFormFields = ''

    for (const shape of this.drawings) {
      if (shape instanceof google.maps.Polygon) {
        polygonCount++;
        // --- Build the pointsString ---
        const path = shape.getPath(); // Get the array of LatLng vertices
        const pointsArray = path.getArray().map(latLng => {
          // For each point, create a "lng,lat" string, multiplying by 1,000,000 and rounding
          const lng = Math.round(latLng.lng() * 1000000);
          const lat = Math.round(latLng.lat() * 1000000);
          return `${lng},${lat}`;
        });
        // close the polygon if it is not already closed.
        if (pointsArray.length > 2 && pointsArray[0] !== pointsArray[pointsArray.length - 1]) {
          pointsArray.push(pointsArray[0]);
        }
        // Join all the "lng,lat" strings together with a semicolon
        const pointsString = pointsArray.join(';');
        let color = shape.get('fillColor').replace('#','');

        let newHiddenString = selectedShapeItemHiddenData.replaceAll('_ITEMNUMBER', polygonCount);
        newHiddenString = newHiddenString.replace('POLYGON_COLOR', color);
        newHiddenString = newHiddenString.replace('POLYGON_NAME', shape.get('shapeName'));
        newHiddenString = newHiddenString.replace('POLYGON_POINTS', pointsString);
        allHiddenFields += newHiddenString

        let newFormGroup = selectedShapeItemFormGroup.replaceAll('_ITEMNUMBER', polygonCount);
        if (shape.get('condition') === details.initialShapeCondition) {
          newFormGroup = newFormGroup.replace('ISCHECKED', 'checked');
        } else {
          newFormGroup = newFormGroup.replace('ISCHECKED', '');
        }
        newFormGroup = newFormGroup.replace('POLYGON_COLOR', '#' + color);
        newFormGroup = newFormGroup.replace('POLYGON_NAME', shape.get('shapeName'));
        allFormFields += newFormGroup;
      }
    }

    setTimeout(() => {
      window.dispatchEvent(new CustomEvent("display-local-modal", {
        detail: {
          modalCssClasses: "modal-dialog c-modal c-modal-gray",
          modalContentCssClasses: "c-modal__content--white",
          modalHeader: `<div class="t-title--large">Add Polygons to My Map Overlay</div>`,
          modalFooterContent: mapModals.overlayModalButtons,
          modalContent: mapModals.addOverlayModal(allHiddenFields, polygonCount, allFormFields),
          modalDataController: "overlay-editor-modal",
          modalDataAction: "map:newOverlayCreated@window->modal#dismissLocal map:overlayUpdated@window->modal#dismissLocal"
        }
      }));
    }, 10)

  }
}
